import { FC, memo } from "react";
import { ChatMessageComponent, Props } from "./ChatMessage";

export const MemoizedChatMessage: FC<Props> = memo(
    ChatMessageComponent,
    (prevProps, nextProps) => (
        prevProps.message.content === nextProps.message.content
    )
);
